import { chartEmptyValueConstants } from '@/utils/reports/chartEmptyValueConstants';

const emptyKeyMap = {
  hires_department_chart: 'department',
  hires_source_chart: 'appl_source',
};

/**
 * Transforms interview data for feedback and duration charts
 * @param response API response data
 * @param feedbackKeys keys for feedback metrics
 * @returns Object containing data for both charts
 */
export const hiresVisualsTransformer = ({ response, metadata }) => {
  const { table = [], lookups: { g1 = {}, g1_l2 = [] } = {} } = response || {};

  const { tileKey } = metadata || {};
  const emptyKey = emptyKeyMap[tileKey];

  const formattedData = table?.map((curr) => {
    const group = curr[2];
    const value = curr[4];

    if (Array.isArray(g1[group])) {
      const nameLookup = g1?.[group]?.map((g1) => g1_l2[g1]?.name);
      return { value, name: nameLookup?.join(',') };
    }

    if (typeof g1[group] === 'object') {
      return { value, ...g1[group] };
    }
    return { value, key: g1[group] };
  }, []);

  const series = [];
  const categories = [];

  formattedData?.forEach((x) => {
    series.push({
      name: x?.name || chartEmptyValueConstants[emptyKey] || 'Not found',
      y: x?.value,
      g1: x?.id || null,
    });
    categories.push(
      x?.name || chartEmptyValueConstants[emptyKey] || 'Not found'
    );
  });

  const result = formattedData?.map((x) => {
    return {
      name: x?.name || chartEmptyValueConstants[emptyKey] || 'Not found',
      y: x?.value,
      g1: x?.id || null,
    };
  });

  if (tileKey === 'hires_department_chart') {
    const departmentCategories = result.map((item) => item.name);

    return {
      series: result,
      categories: departmentCategories, // For bar/column charts
    };
  }

  return {
    series,
    categories,
  };
};
